import { render } from "./EditionPermis.vue?vue&type=template&id=2f496ca4&scoped=true"
import script from "./EditionPermis.vue?vue&type=script&lang=js"
export * from "./EditionPermis.vue?vue&type=script&lang=js"

import "./EditionPermis.vue?vue&type=style&index=0&id=2f496ca4&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f496ca4"]])

export default __exports__